import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function ServiceSuccessPage() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [o, setO] = useState(null);
  const [tries, setTries] = useState(0);
  useEffect(() => {
    if (!sid) return;
    api.get(`/services/status/${sid}`).then((r) => {
      setO(r.data);
      if (r.data.payment_status !== "paid" && tries < 8) setTimeout(() => setTries((t) => t + 1), 2000);
    }).catch(() => {});
  }, [sid, tries]);
  if (!o) return <div className="px-4 py-32 text-center text-neutral-500"><Loader2 className="mx-auto h-6 w-6 animate-spin" /></div>;
  const paid = o.payment_status === "paid";
  const label = { deposit_paid: "Deposit received", paid_in_full: "Paid in full", paid: "Payment received" }[o.status] || "Processing";
  return (
    <div className="mx-auto max-w-xl px-4 py-24 text-center" data-testid="service-success-page">
      <div className={`mx-auto flex h-16 w-16 items-center justify-center rounded-full text-3xl ${paid ? "bg-green-500/20 text-green-400" : "bg-stone-700 text-neutral-300"}`}>{paid ? "✓" : "…"}</div>
      <span className="eyebrow mt-6 block">{paid ? label : "Confirming payment"}</span>
      <h1 className="mt-2 font-display text-4xl uppercase text-chrome" data-testid="service-success-title">{o.service_name}</h1>
      <p className="mt-3 text-neutral-400">{o.name} · ${Number(o.amount).toLocaleString()}</p>
      <div className="mt-2 font-display text-2xl tracking-wider text-gold" data-testid="service-reference">{o.reference_code}</div>
      {paid && <p className="mt-4 text-sm text-neutral-400" data-testid="service-next">
        {o.payment_type === "deposit" ? "Your deposit starts the Planning Blueprint. The $150 balance is due before delivery — we'll send the link when the plan is ready. Nothing is charged automatically."
          : o.payment_type === "balance" ? "Your Planning Blueprint is paid in full. Delivery follows within one business day."
          : "We'll contact you within one business day to arrange delivery. A confirmation with next steps is in your inbox."}
      </p>}
      <div className="mt-8"><Link to="/products" className="font-cond font-bold uppercase text-neutral-400 hover:text-white">Back to services</Link></div>
    </div>
  );
}
